(() => {
  const forms = document.querySelectorAll('[data-wdlt-filters]');
  if (!forms.length) return;
  const stateKey = 'wdlt-filter-open:' + location.pathname;
  let opened = [];
  try { opened = JSON.parse(sessionStorage.getItem(stateKey) || '[]'); } catch (_) {}
  forms.forEach(form => {

    const footwear=form.hasAttribute('data-footwear-sizes');
    const sizeLabel=value=>{
      const raw=value.trim().toUpperCase().replace(/\s*\(/g,' (');
      if(!footwear)return raw;
      const eu=raw.match(/\bEU\s*(\d+(?:\.\d+)?[⅓⅔½]?)/);
      if(eu)return 'EU '+eu[1];
      if(/^\d+(?:\.\d+)?[⅓⅔½]?$/.test(raw))return 'EU '+raw;
      return raw;
    };
    const sizeKey=value=>sizeLabel(value).replace(/\s+/g,'');
    const sizeGroups = new Map();
    form.querySelectorAll('[data-filter-group="size"] .wdlt-filter-choice').forEach(label=>{
      const input=label.querySelector('input');
      label.querySelector('span').textContent=sizeLabel(input.value);
      const normalized=sizeKey(input.value);
      if(!sizeGroups.has(normalized))sizeGroups.set(normalized,[]);
      sizeGroups.get(normalized).push({label,input});
    });
    sizeGroups.forEach(items=>{
      const first=items[0];
      const enabled=items.some(item=>!item.input.disabled);
      const selected=items.some(item=>item.input.checked);
      first.input.disabled=!enabled;
      first.input.checked=selected;first.input.defaultChecked=selected;
      first.label.classList.toggle('wdlt-filter-unavailable',!enabled);
      items.slice(1).forEach(item=>{
        item.label.hidden=true;item.label.dataset.wdltDuplicate='true';
        item.input.disabled=false;
        item.input.checked=selected;item.input.defaultChecked=selected;
      });
      first.input.addEventListener('change',()=>items.slice(1).forEach(item=>{item.input.checked=first.input.checked;}));
    });
    if(footwear){
      const order=value=>Number.parseFloat(value)+(value.includes('⅓')?1/3:value.includes('⅔')?2/3:value.includes('½')?.5:0);
      const container=form.querySelector('[data-filter-group="size"] .wdlt-filter-values');
      if(container)Array.from(sizeGroups.values()).sort((a,b)=>{
        const x=sizeLabel(a[0].input.value),y=sizeLabel(b[0].input.value);
        return order(x.replace('EU ',''))-order(y.replace('EU ',''))||x.localeCompare(y);
      }).forEach(items=>items.forEach(item=>container.append(item.label)));
    }
    const selectedSizes=new Set();
    let duplicateSizes=0;
    form.querySelectorAll('[data-wdlt-remove][data-filter-param="filter.v.option.size"]').forEach(link=>{
      const key=sizeKey(link.dataset.filterValue);
      if(selectedSizes.has(key)){link.hidden=true;duplicateSizes++;}else selectedSizes.add(key);
      const text=link.firstChild;
      if(text?.nodeType===Node.TEXT_NODE)text.textContent=text.textContent.replace(link.dataset.filterValue,sizeLabel(link.dataset.filterValue));
    });
    if(duplicateSizes){const title=form.querySelector('.wdlt-filters-title');title.textContent=title.textContent.replace(/\((\d+)\)/,(_,n)=>'('+(Number(n)-duplicateSizes)+')');}
    const category=form.querySelector('[data-size-category]');
    category?.addEventListener('change',()=>{
      if(!category.value)return;
      const url=new URL(location.href);
      const wasSale=url.pathname.endsWith('/men-sales');
      [...url.searchParams.keys()].filter(key=>key.startsWith('filter.')||key==='wdlt_sale').forEach(key=>url.searchParams.delete(key));
      for(const [key,value] of new FormData(form)){if(value&&key!=='filter.v.option.size'&&key!=='sort_by')url.searchParams.append(key,value);}
      if(wasSale)url.searchParams.set('wdlt_sale','1');
      url.pathname=category.value;
      url.searchParams.delete('filter.v.option.size');
      url.searchParams.delete('page');url.searchParams.delete('wdlt_page');
      if(!url.searchParams.has('sort_by'))url.searchParams.set('sort_by','created-descending');
      try{sessionStorage.setItem('wdlt-filter-open:'+url.pathname,JSON.stringify(['size']));}catch(_){}
      location.assign(url);
    });

    const sale=form.querySelector('[data-sale-only]');
    if(sale){sale.checked=new URLSearchParams(location.search).get('wdlt_sale')==='1';sale.defaultChecked=sale.checked;}
    const drawer = form.closest('.wdlt-filter-drawer');
    if (drawer) {
      const wrapper = drawer.closest('details');
      const trigger = wrapper?.querySelector(':scope > summary');
      document.body.append(drawer);
      if (trigger) {
        trigger.setAttribute('aria-haspopup','dialog');
        trigger.setAttribute('aria-controls',drawer.id);
        trigger.setAttribute('aria-expanded','false');
        trigger.addEventListener('click',event=>{
          event.preventDefault();
          if (!matchMedia('(max-width:989px)').matches) return;
          wrapper.open=false;
          drawer.showModal();
          document.documentElement.classList.add('wdlt-drawer-lock');
          trigger.setAttribute('aria-expanded','true');
          drawer.querySelector('#WdltFilterDrawerTitle').focus({preventScroll:true});
        });
      }
      drawer.querySelector('[data-drawer-close]').addEventListener('click',()=>drawer.close());
      let outside=false;
      drawer.addEventListener('pointerdown',event=>{outside=event.target===drawer && event.clientX>=drawer.getBoundingClientRect().right;});
      drawer.addEventListener('click',event=>{if(outside && event.target===drawer) drawer.close();outside=false;});
      drawer.addEventListener('close',()=>{
        document.documentElement.classList.remove('wdlt-drawer-lock');
        trigger?.setAttribute('aria-expanded','false');
        form.reset();
        const search=form.querySelector('[data-brand-search]');
        if(search){search.value='';search.dispatchEvent(new Event('input'));}
        const error=form.querySelector('.wdlt-price-error');
        if(error)error.hidden=true;
        trigger?.focus({preventScroll:true});
      });
      matchMedia('(max-width:989px)').addEventListener('change',event=>{if(!event.matches && drawer.open)drawer.close();});
      const search=form.querySelector('[data-brand-search]');
      if(search){
        const wrap=document.createElement('div');wrap.className='wdlt-brand-search-wrap';
        search.before(wrap);wrap.append(search);
        const ghost=document.createElement('span');ghost.className='wdlt-brand-ghost';ghost.setAttribute('aria-hidden','true');
        const typed=document.createElement('span'),suffix=document.createElement('span');ghost.append(typed,suffix);wrap.prepend(ghost);
        search.autocomplete='off';search.spellcheck=false;
        const empty=document.createElement('p');empty.className='wdlt-brand-empty';empty.hidden=true;
        empty.setAttribute('role','status');empty.textContent='No matching brands in this collection.';wrap.after(empty);
        search.addEventListener('input',()=>{
          const query=search.value.trim().toLocaleLowerCase();
          const labels=[...form.querySelectorAll('[data-filter-group="brands"] .wdlt-filter-choice')];
          labels.forEach(label=>{label.hidden=!label.textContent.trim().toLocaleLowerCase().includes(query);});
          empty.hidden=!query || labels.some(label=>!label.hidden);
          const match=query ? labels.find(label=>!label.hidden && !label.querySelector('input').disabled && label.textContent.trim().toLocaleLowerCase().startsWith(query)) : null;
          typed.textContent=search.value;
          suffix.textContent=match ? match.textContent.trim().slice(search.value.length) : '';
        });
      }
      form.querySelector('[data-drawer-clear]').addEventListener('click',()=>{
        form.querySelectorAll('input[type="checkbox"]').forEach(input=>{input.checked=false;});
        form.querySelectorAll('input[type="number"],input[type="search"]').forEach(input=>{input.value='';});
        form.querySelectorAll('.wdlt-filter-choice').forEach(label=>{label.hidden=label.dataset.wdltDuplicate==='true';});
        form.querySelector('[data-brand-search]')?.dispatchEvent(new Event('input'));
        const error=form.querySelector('.wdlt-price-error');if(error)error.hidden=true;
      });
    }

    form.querySelectorAll('[data-filter-group]').forEach(group => {
      if (opened.includes(group.dataset.filterGroup)) group.open = true;
    });
    function saveState() {
      const groups = [...form.querySelectorAll('[data-filter-group][open]')].map(group=>group.dataset.filterGroup);
      try { sessionStorage.setItem(stateKey, JSON.stringify(groups)); } catch (_) {}
    }
    form.addEventListener('toggle', saveState, true);
    const minimum = form.querySelector('[name="filter.v.price.gte"]');
    const maximum = form.querySelector('[name="filter.v.price.lte"]');
    function apply(event) {
      event.preventDefault();
      const error = form.querySelector('.wdlt-price-error');
      const invalid = minimum && maximum && minimum.value !== '' && maximum.value !== '' && Number(minimum.value) > Number(maximum.value);
      if (error) error.hidden = !invalid;
      if (invalid || !form.reportValidity()) {
        if (invalid && drawer) { const group=minimum.closest('details'); if(group)group.open=true; minimum.focus(); }
        return;
      }
      saveState();
      const url = new URL(location.href);
      [...url.searchParams.keys()].filter(key=>key.startsWith('filter.') || key==='wdlt_sale' || key==='page' || key==='wdlt_page').forEach(key=>url.searchParams.delete(key));
      for (const [key,value] of new FormData(form)) {
        if (!value || key==='sort_by') continue;
        url.searchParams.append(key,value);
      }
      if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by','created-descending');
      location.assign(url);
    }
    form.addEventListener('submit',apply);
    form.addEventListener('change',event=>{
      if (event.target.type==='checkbox' && !drawer) apply(event);
    });
    form.querySelectorAll('[data-wdlt-remove]').forEach(link => link.addEventListener('click', event => {
      if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const url = new URL(location.href);
      if (link.hasAttribute('data-filter-price')) {
        url.searchParams.delete('filter.v.price.gte');
        url.searchParams.delete('filter.v.price.lte');
      } else {
        const key = link.dataset.filterParam;
        const remaining = url.searchParams.getAll(key).filter(value => (key==='filter.v.option.size' ? sizeKey(value) !== sizeKey(link.dataset.filterValue) : value !== link.dataset.filterValue));
        url.searchParams.delete(key);
        remaining.forEach(value => url.searchParams.append(key, value));
      }
      url.searchParams.delete('page');
      url.searchParams.delete('wdlt_page');
      location.assign(url);
    }));
    form.querySelector('[data-wdlt-clear]')?.addEventListener('click',event=>{
      if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const url=new URL(location.href);
      [...url.searchParams.keys()].filter(key=>key.startsWith('filter.') || key==='wdlt_sale' || key==='page' || key==='wdlt_page').forEach(key=>url.searchParams.delete(key));
      try { sessionStorage.removeItem(stateKey); } catch (_) {}
      location.assign(url);
    });
  });
})();

